export const T = {
  en_GB: {
    title: "What's new",
    description: "Recent release notes and product updates.",
    gotIt: "Got it",
  },
  nb_NO: {
    title: "Nyheter",
    description: "Siste versjonsnotater og produktoppdateringer.",
    gotIt: "Skjønner",
  },
} as const;
